import { IDIOMA_FUENTE } from "../constants/propiedadIdiomas";
import { fallbackLabel } from "../constants/propiedadLabelsFallback";
import { translateUiString } from "./propiedadUiStrings";

/** Campos web con columna dedicada por idioma. */
const CAMPOS_COLUMNA_I18N = [
  { fuente: "web_titulo", es: "web_titulo", prefijo: "web_titulo" },
  { fuente: "web_desc_corta_es", es: "web_desc_corta_es", prefijo: "web_desc_corta" },
  { fuente: "web_desc_larga_es", es: "web_desc_larga_es", prefijo: "web_desc_larga" },
];

/** Campos traducidos en JSONB i18n_textos (muestra en sección Idioma). */
export const CAMPOS_I18N_PREVIEW = [
  "titulo", "tipo_inmueble_nombre", "orientacion_nombre", "estado_inmueble_nombre",
  "poblacion_nombre", "zona_nombre", "nombre_via", "eq_observaciones",
  "precio_observaciones", "info_visita", "reg_observaciones",
];

function parseJson(raw) {
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

/** Valor mostrable de un campo i18n según idioma de vista. */
export function valorCampoI18n(form, campoFuente, idioma = IDIOMA_FUENTE) {
  const lang = idioma || IDIOMA_FUENTE;
  if (lang === IDIOMA_FUENTE) {
    return form[campoFuente] ?? "";
  }

  const i18n = parseJson(form.i18n_textos);

  const col = CAMPOS_COLUMNA_I18N.find((c) => c.fuente === campoFuente);
  if (col) {
    if (col.fuente === "web_titulo") {
      const colLang = form[`web_titulo_${lang}`];
      if (colLang) return colLang;
      const desdeJsonb = i18n.titulo?.[lang] || i18n.web_titulo?.[lang];
      if (desdeJsonb) return desdeJsonb;
      return form.web_titulo ?? "";
    }
    const suffix = col.prefijo.replace("_es", "");
    return form[`${suffix}_${lang}`] ?? "";
  }

  return i18n[campoFuente]?.[lang] ?? "";
}

export function esModoEdicionFuente(idiomaVista) {
  return !idiomaVista || idiomaVista === IDIOMA_FUENTE;
}

/** Label desde mapa API o fallback ES. */
export function labelCampo(mapa, campoKey, idioma, fallback) {
  const row = mapa?.[campoKey];
  const l = idioma || IDIOMA_FUENTE;
  if (row) {
    if (l === IDIOMA_FUENTE) return row.label_es || fallback || campoKey;
    return row[`label_${l}`] || row.label_es || fallback || campoKey;
  }
  return fallbackLabel(l, campoKey, fallback || campoKey);
}

/** Formulario de solo lectura con valores traducidos superpuestos. */
export function buildFormVista(form, idioma) {
  if (esModoEdicionFuente(idioma)) return form;
  const f = { ...form };
  f.web_titulo = valorCampoI18n(form, "web_titulo", idioma);
  f.web_desc_corta_es = valorCampoI18n(form, "web_desc_corta_es", idioma);
  f.web_desc_larga_es = valorCampoI18n(form, "web_desc_larga_es", idioma);
  const i18n = parseJson(form.i18n_textos);
  for (const [campo, langs] of Object.entries(i18n)) {
    if (langs && langs[idioma]) f[campo] = langs[idioma];
  }
  // Título interno / cabecera: alinear con web_titulo traducido si aplica
  const tituloTrad = valorCampoI18n(form, "web_titulo", idioma);
  if (tituloTrad && tituloTrad !== (form.web_titulo ?? "")) {
    f.titulo = tituloTrad;
  }
  return f;
}

/** Mapa texto ES → traducción desde filas crm_campo_labels_i18n. */
export function buildEsTextMapFromLabels(labelsMap, idioma) {
  if (!idioma || idioma === IDIOMA_FUENTE) return {};
  const lang = String(idioma).toLowerCase();
  const col = `label_${lang}`;
  const out = {};
  for (const row of Object.values(labelsMap || {})) {
    if (row?.label_es && row[col]) out[row.label_es] = row[col];
  }
  return out;
}

export function makeLabelFn(mapa, idioma) {
  return (campoKey, fallback) => labelCampo(mapa, campoKey, idioma, fallback);
}

export { translateUiString };
